import { Text } from "react-native-paper";
import { StyleSheet, View } from "react-native";
import { ScheduleViewModel } from "@viewModels/Schedule.viewModel";
import { useTranslation } from "react-i18next";
import { BodyGray } from "@components/texts/BodyGray";
import { theme } from "@config/Theme";
import { weekDays } from "@infrastructure/Utils";

interface Props {
  schedule: Array<ScheduleViewModel>;
}

export const KanguroPointScheduleList = ({ schedule }: Props) => {
  const { t } = useTranslation("common");

  const scheduleByDay = schedule.reduce((prev, acc) => {
    const dayOfWeek = acc.dayOfWeek;
    if (!prev[dayOfWeek]) {
      prev[dayOfWeek] = [];
    }
    prev[acc.dayOfWeek].push(acc);
    return prev;
  }, {} as Record<number, ScheduleViewModel[]>);

  if (schedule.length === 0) return null;

  // Note: Holiday item will locate a full day, so it will make all intervals closed
  const isHoliday = (dayOfWeek: number) =>
    scheduleByDay[dayOfWeek].every((s) => s.isHoliday);

  return (
    <View style={{ paddingTop: 16 }}>
      {weekDays.map((s: string, i: number) => {
        return (
          <View key={i} style={{ flexDirection: "row", paddingBottom: 10 }}>
            <BodyGray style={styles.weekdays}>{t(s)}</BodyGray>
            <View style={{ flex: 0.5 }}>
              {i in scheduleByDay && !isHoliday(i) ? (
                scheduleByDay[i].map((interval) => {
                  return (
                    <View key={interval.id} style={styles.scheduleRow}>
                      <Text
                        style={{ fontSize: 14 }}
                        variant="bodySmall"
                      >{`${interval.open} - ${interval.close}`}</Text>
                    </View>
                  );
                })
              ) : i in scheduleByDay && isHoliday(i) ? (
                <View key={"closed" + i} style={styles.closedDay}>
                  <Text
                    variant="bodySmall"
                    style={{ flex: 1, alignSelf: "center", textAlign: "left" }}
                  >
                    {t("holiday_closed")}
                  </Text>
                </View>
              ) : (
                <View key={"closed" + i} style={styles.closedDay}>
                  <Text
                    variant="bodySmall"
                    style={{ flex: 1, alignSelf: "center", textAlign: "left" }}
                  >
                    {t("kanguropointScheduleList_closed")}
                  </Text>
                </View>
              )}
            </View>
          </View>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  weekdays: {
    fontSize: 13,
    fontWeight: "400",
    fontFamily: "Poppins-Regular",
    color: theme.colors.info,
    flex: 0.6,
  },

  scheduleRow: {
    flexDirection: "row",
    justifyContent: "flex-start",
    flexGrow: 1,
    gap: 10,
  },
  closedTag: {
    color: "red",
    alignSelf: "center",
    textAlign: "center",
    fontSize: 12,
  },

  closedDay: {
    flexDirection: "row",
    alignItems: "center",
    alignContent: "center",
    flex: 1,
  },
});
